import { render, staticRenderFns } from "./PaymentCategoryDetail.vue?vue&type=template&id=2d165ec0"
import script from "./PaymentCategoryDetail.vue?vue&type=script&lang=js"
export * from "./PaymentCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports